(function () {
  'use strict';

  function cardStep(track) {
    var card = track.querySelector('.brand-spotlight__card');
    if (!card) return track.clientWidth || 1;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var width = card.getBoundingClientRect().width;
    if (width < 1) return track.clientWidth || 1;
    return width + gap;
  }

  function pageCount(track) {
    var cards = track.querySelectorAll('.brand-spotlight__card').length;
    var step = cardStep(track);
    var visible = Math.max(1, Math.round((track.clientWidth + 4) / step));
    if (visible > cards) visible = cards;
    return Math.max(1, cards - visible + 1);
  }

  function activeIndex(track) {
    var step = cardStep(track);
    var index = Math.round(track.scrollLeft / step);
    var max = pageCount(track) - 1;
    if (index < 0) return 0;
    if (index > max) return max;
    return index;
  }

  function update(root) {
    var track = root.querySelector('[data-brand-spotlight-track]');
    var prevBtn = root.querySelector('[data-brand-spotlight-prev]');
    var nextBtn = root.querySelector('[data-brand-spotlight-next]');
    var dotsWrap = root.querySelector('[data-brand-spotlight-dots]');
    if (!track || !prevBtn || !nextBtn) return;

    var pages = pageCount(track);
    var index = activeIndex(track);
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    var single = pages < 2;

    prevBtn.disabled = single || atStart;
    nextBtn.disabled = single || atEnd;
    prevBtn.hidden = single;
    nextBtn.hidden = single;
    root.classList.toggle('is-single', single);

    if (!dotsWrap) return;

    if (dotsWrap.childElementCount !== pages) {
      var labelPrefix = root.getAttribute('data-dot-label') || 'Show product';
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i += 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'brand-spotlight__dot';
        dot.setAttribute('aria-label', labelPrefix + ' ' + (i + 1));
        dot.dataset.index = String(i);
        dotsWrap.appendChild(dot);
      }
    }

    dotsWrap.hidden = single;
    var dots = dotsWrap.querySelectorAll('.brand-spotlight__dot');
    for (var d = 0; d < dots.length; d += 1) {
      var on = d === index;
      dots[d].classList.toggle('is-active', on);
      if (on) {
        dots[d].setAttribute('aria-current', 'true');
      } else {
        dots[d].removeAttribute('aria-current');
      }
    }
  }

  function scrollToIndex(root, index) {
    var track = root.querySelector('[data-brand-spotlight-track]');
    if (!track) return;
    var max = pageCount(track) - 1;
    var next = index;
    if (next < 0) next = 0;
    if (next > max) next = max;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({
      left: next * cardStep(track),
      behavior: reduce ? 'auto' : 'smooth'
    });
  }

  function init(root) {
    if (!root || root.dataset.brandSpotlightReady === 'true') return;
    root.dataset.brandSpotlightReady = 'true';

    var track = root.querySelector('[data-brand-spotlight-track]');
    var prevBtn = root.querySelector('[data-brand-spotlight-prev]');
    var nextBtn = root.querySelector('[data-brand-spotlight-next]');
    var dotsWrap = root.querySelector('[data-brand-spotlight-dots]');
    if (!track || !prevBtn || !nextBtn) return;

    prevBtn.addEventListener('click', function () {
      scrollToIndex(root, activeIndex(track) - 1);
    });

    nextBtn.addEventListener('click', function () {
      scrollToIndex(root, activeIndex(track) + 1);
    });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('.brand-spotlight__dot');
        if (!dot || !dotsWrap.contains(dot)) return;
        scrollToIndex(root, parseInt(dot.dataset.index, 10) || 0);
      });
    }

    track.addEventListener('scroll', function () {
      update(root);
    }, { passive: true });

    window.addEventListener('resize', function () {
      update(root);
    });

    update(root);
  }

  function initAll() {
    document.querySelectorAll('[data-brand-spotlight]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
